/* ------------------------------------------ Start ------------------------------ */

// modify ajax and requests
$.ajaxSetup({
  cache: false,
});

/* ------------------------------------------ Ajax Globals ------------------------------ */

// injects missing tokens / logout removed
$(document).ajaxSuccess(function () {
  initInjectMissingTokens();
});

/**
 * Global Ajax error notification
 * 		usually called in the jquery $.ajax({... error: function
 * @param {json} - jqXHR js returned from server
 * @param {String} textStatus - error, etc from server
 * @param {String} errorThrown - slightly more descriptive error from server
 * @param {String} source - new optional string identifying the function throwing the error
 * @param {boolean} showModal - use false if you have an alternative way of handling the error on the front end, assumed to be true
 * @return void - posts a Bugsnag notification and pops a error modal
 */
function processAjaxError(jqXHR, textStatus, errorThrown, source, showModal) {
  // console.log("%c----------------------------------------------------------","color:green;font-weight:bold;");
  // console.log("processAjaxError() jqXHR: ", jqXHR);
  // console.log("processAjaxError() textStatus: ", textStatus);
  // console.log("processAjaxError() errorThrown: ", errorThrown);
  // console.log("processAjaxError() source: ", source);
  let showAlertModal = showModal != false;
  let src = source ? source : "unidentified";
  let rText;
  if (isJSON(jqXHR.responseText)) {
    let response = JSON.parse(jqXHR.responseText);
    let errorsString = response.errors ? response.errors.toString() : "";
    rText =
      ", responseText.Detail = " +
      response.DETAIL +
      ", responseText.Error = " +
      response.ERROR +
      ", responseText.Message = " +
      response.Message +
      ", responseText.errors: " +
      errorsString;
  } else {
    rText = jqXHR.responseText;
  }

  let bugReport =
    " status = " +
    jqXHR.status +
    ", statusText = " +
    jqXHR.statusText +
    ", responseText: " +
    rText +
    ", source = " +
    src;

  Bugsnag.notify("_AjaxGeneral.js::processAjaxError() " + bugReport);

  if (showAlertModal) {
    var msgProblem = getTranslation("JavaScript.ProblemCommunicatingWithServer");
    var msgTryAgain = getTranslation("JavaScript.PleaseTryAgain");
    alertDialog({
      msg: msgProblem + "<br /><br />" + msgTryAgain,
      html: true,
    });
  }
}

/* ------------------------------------------ Ajax Init ------------------------------ */

// Setup from #pageWrapper
// Provides live page updates for the page that you're on
function initAjaxIntervalUpdates() {
  var config = new Array();

  if ($("#pageWrapper").length) {
    config.push("NOTIFICATIONS");

    // #Clock
    if ($("#clock").length > 0) {
      config.push("CURRENTLOCALTIME");
      GetAjaxCurrentLocalTime();
    }

    // #ClockOut
    if ($("#large-button-clockout").length > 0 || $("#HoursWorkedTodayAjax").length > 0) {
      config.push("USERONCLOCK");
      GetAjaxHoursOnTheClock();
    }

    // #MessageCenter
    if ($("#MessageCenterMsgTextBox").length > 0 || $("#MessageCenter").length > 0) {
      config.push("MESSAGECENTER");
      GetAjaxMessageCenterCount();
    }

    // #Timer
    if ($("div.UpdateHoursTimer").length > 0) {
      GetProjectTimers();
    }

    // set to Global Scope
    g.ajaxUpdateObj.itemsRequested = config;

    // update interval
    if (g.ajaxUpdateObj.interval) {
      clearInterval(g.ajaxUpdateObj.interval);
    }
    g.ajaxUpdateObj.interval = setInterval(ajaxIntervalUpdate, g.ajaxUpdateObj.ms);

    // set timeout for window
    setTimeout(function () {
      $(window)
        .on("blur.ajaxIntervalUpdate", function () {
          g.windowIsFocused = false;
        })
        .on("focus.ajaxIntervalUpdate", function () {
          if (!g.windowIsFocused) {
            ajaxIntervalUpdate();
            g.windowIsFocused = true;
          }
        })
        .on("unload.ajaxIntervalUpdate pagehide.ajaxIntervalUpdate", function () {
          clearInterval(g.ajaxUpdateObj.interval);
        });
    }, 1000);
  }
}

/* ------------------ Ajax Re-Calls to Live Page ------------------ */

// Based upon the interval re-up
function ajaxIntervalUpdate() {
  if (typeof document !== "undefined" && document.hidden) {
    return;
  }

  var ajaxRequestArray = g.ajaxUpdateObj.itemsRequested;
  var ajaxTimersArray = g.ajaxUpdateObj.projectTimers;

  if (ajaxRequestArray.indexOf("CURRENTLOCALTIME") !== -1) {
    GetAjaxCurrentLocalTime();
  }

  if (ajaxRequestArray.indexOf("USERONCLOCK") !== -1) {
    GetAjaxHoursOnTheClock();
  }

  if (ajaxRequestArray.indexOf("MESSAGECENTER") !== -1) {
    GetAjaxMessageCenterCount();
  }

  if (ajaxTimersArray && ajaxTimersArray.length) {
    GetAjaxProjectTimers();
  }
}

/* ------------------ Ajax Calls --------------------------------- */

// GetAjaxCurrentLocalTime
function GetAjaxCurrentLocalTime() {
  var url = g.baseApiUrl + "/server/time";

  $.ajax({
    url: url,
    type: "GET",
    cache: false,
    dataType: "json",
    headers: createBaseApiHeaders(getApiKeyFromStorage(), getApiTokenFromStorage()),
    success: function (data) {
      // Example Response: {S: "10", H: "16", M: "8"}
      updateClock(data.USERTIME);
    },
  });
}

function GetAjaxHoursOnTheClock() {
  var url = g.baseApiUrl + "/clock/worked";

  $.ajax({
    url: url,
    type: "GET",
    cache: false,
    dataType: "json",
    headers: createBaseApiHeaders(getApiKeyFromStorage(), getApiTokenFromStorage()),
    success: function (data) {
      if (data.USERONCLOCK) {
        // Set DOM
        $("#ClockInLocal").text(data.CLOCKINLOCALFMT);
        $("#HoursWorkedCurrentShiftAjax").text(data.HOURSWORKEDCURRENTSHIFT);
        $("#HoursWorkedTodayAjax").text(data.HOURSWORKEDTODAY);

        // Call and clear updateHrsWorkedToday
        clearInterval(g.hrsWorkedTodayInt);
        g.hrsWorkedTodayInt = setInterval(updateHrsWorkedToday, 60000);
      }
    },
  });
}

function GetAjaxMessageCenterCount() {
  var url = g.baseApiUrl + "/messagecenter/count";

  $.ajax({
    url: url,
    type: "GET",
    cache: false,
    dataType: "json",
    headers: createBaseApiHeaders(getApiKeyFromStorage(), getApiTokenFromStorage()),
    success: function (data) {
      if (data.TotalMessages > 0) {
        let maxMessages = 9; // largest number of messages to show
        let maxMessagesText = "9+"; // what the user sees
        // Total message count
        var displayCount = data.TotalMessages;
        if (displayCount > 9) {
          displayCount = maxMessagesText; // if this increases we'll have to adjust the height and width of #MessageCenterNewMsgCount in _Framework.scss
        }
        $(".MessageCenterNewMsgCount").show();
        $(".MessageCenterNewMsgCount").html(displayCount).removeClass("empty");
        $(".MessageCenterNewMsgCount").html(displayCount).addClass("hasNotification");

        // Notifications
        if (parseInt(data.UnreadNotifications) > maxMessages) {
          $("#NotificationsCount").removeClass("empty").html(maxMessagesText);
        } else if (parseInt(data.UnreadNotifications) != 0) {
          $("#NotificationsCount").removeClass("empty").html(data.UnreadNotifications);
        } else {
          $("#NotificationsCount").addClass("empty");
        }

        // Account Alerts
        if (parseInt(data.UnreadAlerts) > maxMessages) {
          $("#AccountAlertsCount").removeClass("empty").html(maxMessagesText);
        } else if (parseInt(data.UnreadAlerts) != 0) {
          $("#AccountAlertsCount").removeClass("empty").html(data.UnreadAlerts);
        } else {
          $("#AccountAlertsCount").addClass("empty");
        }

        $("#messageCenterIcon").empty().append('<i class="fa fad fa-2x fa-megaphone toggleIcon"></i>');
        $("#messageCenterLeftNavIcon").empty().append('<i class="fa fas fa-megaphone"></i>');

        // Memos
        if (parseInt(data.UnreadMemos) > maxMessages) {
          $("#MemoCount").removeClass("empty").html(maxMessagesText);
        } else if (parseInt(data.UnreadMemos) != 0) {
          $("#MemoCount").removeClass("empty").html(data.UnreadMemos);
        } else {
          $("#MemoCount").addClass("empty");
        }

        // New messages
        if (parseInt(data.NewMessages) > maxMessages) {
          $("#NewMessages").removeClass("empty").html(maxMessagesText);
        } else if (parseInt(data.NewMessages) != 0) {
          $("#NewMessages").removeClass("empty").html(data.NewMessages);
        } else {
          $("#NewMessages").addClass("empty");
        }
      } else {
        $(".MessageCenterNewMsgCount").html("");
        $(".MessageCenterNewMsgCount").removeClass("hasNotification");
        $(".MessageCenterNewMsgCount").addClass("empty");
        $("#messageCenterIcon").empty().append('<i class="fa fad fa-2x fa-megaphone toggleIcon"></i>');
        $("#messageCenterLeftNavIcon").empty().append('<i class="fa fas fa-megaphone"></i>');
      }
    },
  });
}

// GetAjaxProjectTimers
function GetAjaxProjectTimers() {
  var url = g.baseApiUrl + "/project/timers";

  var formdata = { ProjectTimers: $.toJSON(g.ajaxUpdateObj.projectTimers) };

  $.ajax({
    url: url,
    type: "POST",
    cache: false,
    data: formdata,
    dataType: "json",
    headers: createBaseApiHeaders(getApiKeyFromStorage(), getApiTokenFromStorage()),
    success: function (data) {
      if (typeof data === "object") {
        updateAllProjectTimerHours(data.data);
      }
    },
  });
}

// Gets Translations
// GetTranslations("es_MX", "PageTitles", "Sys.Tools.APIAccessSub");
function GetTranslations(language, page, translation) {
  var url = g.baseApiUrl + "/translation/" + language + "/" + page + "/";

  $.ajax({
    url: url,
    type: "POST",
    data: {
      translation: translation,
    },
    cache: false,
    dataType: "json",
    headers: createBaseApiHeaders(getApiKeyFromStorage(), getApiTokenFromStorage()),
    success: function (data) {
      return data;
    },
  });
}

// This function is called by GetAjaxProjectTimers()
function updateAllProjectTimerHours(data) {
  $.each(data, function (i, o) {
    var $e = $(
      "tr[data-userid=" +
        o.USERID +
        "][data-accountcodeid=" +
        o.ACCOUNTCODEID +
        "][data-projectid=" +
        o.PROJECTID +
        "][data-customerid=" +
        o.CUSTOMERID +
        "]",
    );
    if ($e.length > 0) {
      var hoursHtml;
      if (typeof renderProjectTimerHours === "function") {
        hoursHtml = renderProjectTimerHours(o.RUNNINGHOURS);
      } else if (typeof toggleHrsMins === "function") {
        var numericHours = parseFloat(o.RUNNINGHOURS);
        hoursHtml = isFinite(numericHours)
          ? toggleHrsMins(numericHours, g.clientSettingsObj.numberDisplayFormat, "no_format")
          : o.RUNNINGHOURS == null
            ? ""
            : o.RUNNINGHOURS;
      } else {
        hoursHtml = o.RUNNINGHOURS;
      }
      $e.find("div.UpdateHoursTimer, span.UpdateHoursTimer").fadeOut(250).html(hoursHtml).fadeIn(500);
    } else {
      $e.slideUp(2000, function () {
        $(this).remove();
        showHideAllButtons();
      });
    }
  });
}

// Isolated into its own function GETPROJECTIMERS
function GetProjectTimers() {
  g.ajaxUpdateObj.projectTimers = new Array();
  $("div.UpdateHoursTimer").each(function () {
    g.ajaxUpdateObj.projectTimers.push($(this).closest("tr").data());
  });
}

/* ------------------------------------------ Handler Functions ------------------------------ */

// adds class (submitAjaxForm)
// with any form that contains (IsAjax)
// TODO @miles REFACTOR WEEK VIEW I think this is the only place left, remove it
function setAjaxFormsSubmitHandler() {
  $("form:has(input[name=IsAjax][value=true]):not(.submitajaxform)").addClass("submitajaxform");
  $("#pageWrapper").on("submit", "form:has(input[name=IsAjax][value=true])", function (ev) {
    if (!ev.isDefaultPrevented()) {
      $(this).ajaxSubmit();
      return false;
    }
  });
}

/* ------------------------------------------ Extension Functions ------------------------------ */

// TODO @miles REFACTOR WEEK VIEW REMOVE THIS

// called everywhere
// AJAX ENDPOINT
$.fn.extend({
  ajaxSubmit: function () {
    var dataObj = {};
    dataObj = $(this).serializeJSON();
    $.ajax({
      type: "POST",
      url: $(this).attr("action"),
      data: dataObj,
      dataType: "html",
      cache: false,
      success: function (returnToJS) {
        //ignore:eval
        eval(returnToJS);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        processAjaxError(jqXHR, textStatus, errorThrown);
      },
    });
    return false;
  },
});

/* ------------------------------------------ Debug and Errors ------------------------------ */

// debugging filter
$.ajaxPrefilter(function (opts, originalOptions, jqXHR) {
  if (opts.data) {
    if (opts.data.indexOf("&Token") == -1) opts.data += "&Token=" + g.csrfToken;
  }
});
